export const newsItems = [
  {
    id: 'corporate-site-launch',
    date: '2026.02.01',
    title: 'コーポレートサイトを開設しました',
    category: 'お知らせ',
  },
];
